import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4422b950"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "practice-people-signatories" }
const _hoisted_2 = { class: "search-inputs" }
const _hoisted_3 = { class: "search-bar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-hm" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-filter fa-lg" })
], -1))
const _hoisted_5 = {
  class: "checkbox-button ml-2",
  style: {"min-width":"170px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "checkmark-box",
    style: {"align-self":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Show active only")
], -1))
const _hoisted_7 = { class: "checkbox-button ml-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "checkmark-box",
    style: {"align-self":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "PC")
], -1))
const _hoisted_9 = { style: {"width":"calc(100% - 700px)","text-align":"right"} }
const _hoisted_10 = { class: "ls-table" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "text" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-up" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["colspan"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["colspan"]
const _hoisted_19 = { key: 2 }
const _hoisted_20 = ["colspan"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { "data-label": "LawId" }
const _hoisted_23 = { "data-label": "Name" }
const _hoisted_24 = { "data-label": "Categories" }
const _hoisted_25 = { "data-label": "Solely-jointly" }
const _hoisted_26 = { "data-label": "From" }
const _hoisted_27 = { "data-label": "To" }
const _hoisted_28 = {
  "data-label": "Action",
  style: {"text-align":"right"}
}
const _hoisted_29 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_AddEditSignatoryModal = _resolveComponent("AddEditSignatoryModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchKeyword) = $event)),
          placeholder: "Filter by LSID, name"
        }, null, 512), [
          [_vModelText, _ctx.searchKeyword]
        ]),
        _hoisted_4
      ]),
      _createElementVNode("label", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.showActiveOnly) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.showActiveOnly]
        ]),
        _hoisted_6
      ]),
      _createElementVNode("label", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.showPCOnly) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.showPCOnly]
        ]),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[3] || (_cache[3] = $event => (_ctx.addNew()))
        }, "Add new signatory")
      ])
    ]),
    _createElementVNode("table", _hoisted_10, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
            return (_openBlock(), _createElementBlock("th", {
              class: _normalizeClass([ h.sortable ? 'sortable' : '']),
              onClick: $event => (_ctx.sortTableColumn(index, h.sortable))
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(h.text), 1),
                (h.sortable)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass([ _ctx.activeSortHeader === index ? 'active' : '', _ctx.sortMethod])
                    }, _hoisted_14, 2))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_11))
          }), 256))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_ctx.loadingContent)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
              _createElementVNode("td", {
                colspan: _ctx.tableHeadings.length
              }, [
                _createVNode(_component_LoadingIndicator)
              ], 8, _hoisted_16)
            ]))
          : (_ctx.errorLoadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                _createElementVNode("td", {
                  colspan: _ctx.tableHeadings.length
                }, [
                  _createVNode(_component_ErrorIndicator)
                ], 8, _hoisted_18)
              ]))
            : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.signatoriesDisplay.length == 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                  _createElementVNode("td", {
                    colspan: _ctx.tableHeadings.length
                  }, "No Records", 8, _hoisted_20)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.signatoriesDisplay.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.applyFilter(_ctx.signatoriesDisplay), (i) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      ((_ctx.showActiveOnly && _ctx.isActive(i) || !_ctx.showActiveOnly) && (_ctx.showPCOnly && i.signatoryType.name == 'PC' || !_ctx.showPCOnly))
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                            _createElementVNode("td", _hoisted_22, _toDisplayString(i.lawId), 1),
                            _createElementVNode("td", _hoisted_23, _toDisplayString(i.name), 1),
                            _createElementVNode("td", _hoisted_24, _toDisplayString(i.categoryName), 1),
                            _createElementVNode("td", _hoisted_25, _toDisplayString(i.solelyJointly?.name), 1),
                            _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.$formatDate(i.commencedDate)), 1),
                            _createElementVNode("td", _hoisted_27, _toDisplayString(i.terminatedDate ? _ctx.$formatDate(i.terminatedDate) : ''), 1),
                            _createElementVNode("td", _hoisted_28, [
                              _createElementVNode("button", {
                                class: "btn btn-default sml mr-1",
                                onClick: $event => (_ctx.edit(i))
                              }, "Edit", 8, _hoisted_29)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showAddEditModal)
      ? (_openBlock(), _createBlock(_component_AddEditSignatoryModal, {
          key: 0,
          signatoryRequest: _ctx.signatoryRequest,
          "onUpdate:signatoryRequest": _cache[4] || (_cache[4] = $event => ((_ctx.signatoryRequest) = $event)),
          signatories: _ctx.signatories,
          "onUpdate:signatories": _cache[5] || (_cache[5] = $event => ((_ctx.signatories) = $event)),
          categories: _ctx.categories,
          "onUpdate:categories": _cache[6] || (_cache[6] = $event => ((_ctx.categories) = $event)),
          onCloseModal: _cache[7] || (_cache[7] = $event => (_ctx.showAddEditModal = false)),
          onDataChangedSuccessfully: _cache[8] || (_cache[8] = $event => (_ctx.loadTableData(true)))
        }, null, 8, ["signatoryRequest", "signatories", "categories"]))
      : _createCommentVNode("", true)
  ]))
}